<div class="video-container" [ngClass]="{ preview: isPreview }">
  <header>{{ title }}</header>
  <section>
    <span>{{ name }}</span>
    <duration
      *ngIf="duration != null"
      [mediaItem]="getMediaForDuration()"
    ></duration>
  </section>
  <div>
    <video
      poster="{{ poster }}"
      src="{{ urlToPlay }}"
      preload="auto"
      (canplay)="playVideo()"
      (pause)="videoStopped()"
      (ended)="videoStopped()"
    ></video>
  </div>
  <icn-progressbar
    [themeColor]="isPreview ? 'green' : 'red'"
    [value]="15"
    [flat]="true"
    [small]="true"
  ></icn-progressbar>
</div>
<footer>
  <capsule
    [name]="'Graphics'"
    [number]="numOfGraphics"
    [iconName]="'/assets/icons/graphics-black.svg'"
    [ngClass]="{ visible: numOfGraphics > 0, clickable: true }"
    (click)="onAttachedGraphicClick($event)"
  ></capsule>

  <capsule
    [name]="'Audio'"
    [number]="numOfAudio"
    [iconName]="'/assets/icons/graphics-black.svg'"
    [ngClass]="{ visible: numOfAudio > 0, clickable: true }"
  ></capsule>
</footer>
